import React, { useState, useEffect, useRef } from 'react';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { Card, Accordion, Badge } from 'react-bootstrap';
// import { Link, usePage } from '@inertiajs/react';

const AutoGenDisplay = () => {
    const [messages, setMessages] = useState([]);
    const [threadId, setThreadId] = useState(null);
    const [agents, setAgents] = useState({});
    const [newMessageCounts, setNewMessageCounts] = useState({});
    const messagesEndRef = useRef(null);

    useEffect(() => {
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        const echo = new Echo({
            broadcaster: 'pusher',
            key: process.env.MIX_PUSHER_APP_KEY || 'local',
            cluster: process.env.MIX_PUSHER_APP_CLUSTER || 'mt1', // Ensure the cluster is passed
            wsHost: window.location.hostname,
            wsPort: 6001,
            wssPort: 6001,
            forceTLS: false,
            disableStats: true,
            enabledTransports: ['ws', 'wss'],
        });

        echo.channel('autogen')
            .listen('NewAutogenMessage', (e) => {
                setMessages(prevMessages => [...prevMessages, e.message]);
                setNewMessageCounts(prev => ({
                    ...prev,
                    [e.message.agent]: (prev[e.message.agent] || 0) + 1
                }));
            });

        // Initiate AutoGen process and get thread ID
        fetch('/api/start-autogen', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            }
        })
        .then(response => response.json())
        .then(data => setThreadId(data.threadId));

        // Get agent information
        fetch('/api/agent-info', {
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            }
        })
        .then(response => response.json())
        .then(data => {
            const agentInfo = {};
            data.agents.forEach(agent => {
                agentInfo[agent.name] = agent;
            });
            setAgents(agentInfo);
        });

        return () => {
            echo.leaveChannel('autogen');
        };
    }, []);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const groupMessagesByAgent = () => {
        return messages.reduce((acc, message) => {
            if (!acc[message.agent]) {
                acc[message.agent] = [];
            }
            acc[message.agent].push(message);
            return acc;
        }, {});
    };

    const renderAgentCard = (agent, agentMessages) => (
        <Card key={agent} className="mb-3">
            <Card.Header>
                {agent}
                {newMessageCounts[agent] > 0 && (
                    <Badge bg="primary" className="ms-2">
                        {newMessageCounts[agent]} new
                    </Badge>
                )}
            </Card.Header>
            <Card.Body>
                <p><strong>Task:</strong> {agents[agent]?.task}</p>
                <p><strong>Description:</strong> {agents[agent]?.description}</p>
                {agentMessages.map((message, index) => (
                    <Accordion key={index}>
                        <Accordion.Item eventKey={index.toString()}>
                            <Accordion.Header onClick={() => setNewMessageCounts(prev => ({...prev, [agent]: 0}))}>
                                {message.direction} - {new Date(message.timestamp * 1000).toLocaleString()}
                            </Accordion.Header>
                            <Accordion.Body>
                                <p><strong>Content:</strong> {message.data}</p>
                                <p><strong>Context:</strong> {message.context}</p>
                                {message.direction === 'outgoing' && <p><strong>Destination:</strong> {message.destination}</p>}
                                {message.direction === 'incoming' && <p><strong>Origin:</strong> {message.origin}</p>}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                ))}
            </Card.Body>
        </Card>
    );

    return (
        <div>
            <h1>AutoGen Conversation (Thread ID: {threadId})</h1>
            {Object.entries(groupMessagesByAgent()).map(([agent, agentMessages]) => 
                renderAgentCard(agent, agentMessages)
            )}
            <div ref={messagesEndRef} />
        </div>
    );
};

export default AutoGenDisplay;
